var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('PageLeft'),_c('PageRight'),_c('h1',{staticClass:"title"},[_vm._v(" ezio marcelli ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }